'use client';
var parseSegmentQuery = function(query) {
    var correctlyWrapped = query.startsWith("[") && query.endsWith("]");
    if (!correctlyWrapped) {
        return false;
    }
    var body = query.slice(1, -1);
    var _body_replaceAll_split = body.replaceAll(" ", "").split(","), from = _body_replaceAll_split[0], to = _body_replaceAll_split[1];
    if (from && to) {
        return {
            from: from,
            to: to
        };
    }
    return false;
};

export { parseSegmentQuery };
